import { useState, useEffect } from "react";

import './ProductCatalog.css';

import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

import PageTopic from "components/PageTopic";
import { Svg_Delete, Svg_Disabled, Svg_Edit } from "components/Svg";

import { SetListPag } from "interface/Page";
import { SetModalData, SetModalState } from "interface/PopUp";
import { GetDataPage, RegisterDataPage, UnRegisterDataPage } from "interface/Data";

import { colorIcon } from "fixedData";

export default function Page_Administrator_ProductCatalog(props){

    const [ search, setSearch ] = useState('');
    const [ currentData, setCurrentData ] = useState(GetDataPage('product'));

    const [ listOn, setListOn ] = useState(InitialData('all'));
    const [ listOff, setListOff ] = useState(InitialData('deleted'));

    const [ itensPage, setItensPage ] = useState(50);
    const [ showPage, setShowPage ] = useState(0);

    const page = Math.ceil(listOn.length / itensPage);
    const startItens = showPage * itensPage;
    const endItens = startItens + itensPage;
    const currentItens = listOn.slice(startItens, endItens);

    function InitialData(type){
        if(type == "all"){
            const newData = GetDataPage('product').filter(item => item.status == 1);
            return newData;
        }
        if(type == "deleted"){
            const newData = [];
            GetDataPage('product').map((elem, index)=>{
                if(elem.status == 0){
                    newData.push({ "id": elem.id, "type": 'product', "title": elem.title, "removed_name": elem.removed_name, "removed_date": elem.removed_date })
                }
            });
            return newData;
        }
        return [];
    }

    function SearchInput(value){
        const newList = [];
        if(value){
            GetDataPage('product').forEach(item =>{
                console.log(item);
                if(item.status == 1){
                    if(item.title.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                    if(item.subtitle.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                    if(item.desc_title.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                    if(item.description.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                }
            });
            const duplicate = newList.filter((item, index) => newList.indexOf(item) === index);
            setListOn(duplicate);
        }else {
            setListOn(InitialData('all'));
        }
        setSearch(value);
    }

    function PageClick(idPage){
        SetListPag('currentPage', 'product_details');
        SetListPag('currentPageId', idPage);
    }

    function AltStatusProduct(type, id, value){
        SetModalData('Confirmation', { "id": id, "origin": "product", "type": type, "status": 0, "name": value });
        SetModalState('Confirmation', true);
    }

    useEffect(()=>{
        RegisterDataPage('product', setCurrentData);
        return ()=>{
            UnRegisterDataPage('product', setCurrentData);
        };
    }, []);

    useEffect(()=>{
        setCurrentData(GetDataPage('product'));
        
        setListOn(InitialData('all'));
        setListOff(InitialData('deleted'));
    }, [currentData]);

    return(
        <div className="width_page">
            <PageTopic type="block" PageClick={ PageClick } SearchInput={ SearchInput } titlePage="Catálogo de Produtos" historic={ listOff } />

            <div className="list_project">
                <table cellPadding="0" cellSpacing="0">
                    <thead>
                        <tr>
                            <th width="20" align="center">#</th>
                            <th width="120">Código</th>
                            <th>Nome</th>
                            <th width="60" align="right">#</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            currentItens.length > 0 ?
                            currentItens.map((elem, index)=>{
                                return(
                                    <tr key={ index }>
                                        <td align="center">{ startItens + index + 1 }</td>
                                        <td>{ elem.sku }</td>
                                        <td>{ elem.title }</td>
                                        <td align="right">
                                            <div className="list_opt">                                                
                                                <div onClick={ ()=>{ PageClick(elem.id, elem.title, elem.file) } } data-tooltip-id={ "id_edit_" + elem.id } data-tooltip-content="Editar produto" data-tooltip-place="top">
                                                    <Svg_Edit className="icons" color={ colorIcon } />
                                                </div>
                                                <Tooltip id={ "id_edit_" + elem.id } />

                                                <div onClick={ ()=>{ AltStatusProduct('alt_status_profile_0', elem.id, elem.title) } } data-tooltip-id={ "id_access_" + elem.id } data-tooltip-content="Ocultar produto do site" data-tooltip-place="top">
                                                    <Svg_Disabled className="icons" color="#F00000" />
                                                </div>
                                                <Tooltip id={ "id_access_" + elem.id } />

                                                <div onClick={ ()=>{ AltStatusProduct('delete_product', elem.id, elem.title) } } data-tooltip-id={ "id_delete_" + elem.id } data-tooltip-content="Deletar produto" data-tooltip-place="top">
                                                    <Svg_Delete className="icons" color="#F00000" />
                                                </div>
                                                <Tooltip id={ "id_delete_" + elem.id } />
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                            :
                            <tr>
                                <td className="no_data" align="center" colSpan={ 5 }>Nenhum cadastro encontrado...</td>
                            </tr>
                        }
                    </tbody>
                </table>
                {
                    listOn.length >= 50 ?
                    <div className="list_pages">
                        {
                            Array.from(Array(page), (item, index)=>{
                                return(
                                    <div className={ showPage == index ? "numb_page" : "numb_page page_active" } key={ index } onClick={ (e)=>{ setShowPage(index) } }>
                                        { index + 1 }
                                    </div>
                                )
                            })
                        }
                    </div> : null
                }
            </div>
        </div>
    )
}